// extracted by mini-css-extract-plugin
module.exports = {"shopifyInstallWrapper":"ShopifyInstall_shopifyInstallWrapper__2wHJK"};